var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["social/facebook-share.j2"] = require( "social/facebook-share.j2" );
dependencies["social/twitter-share.j2"] = require( "social/twitter-share.j2" );
dependencies["social/pinterest-share.j2"] = require( "social/pinterest-share.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-social-links.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-product-social-links\" data-qa-social-links>\n\n    <p class=\"c-product-footer__p c-product-footer__p--above\">\n         ";
output += runtime.suppressValue((lineno = 3, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-detail_footer-social"])), env.opts.autoescape);
output += "\n    </p>";
var t_1;
t_1 = (lineno = 6, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product",runtime.contextOrFrameLookup(context, frame, "product")]));
frame.set("productData", t_1, true);
if(frame.topLevel) {
context.setVariable("productData", t_1);
}
if(frame.topLevel) {
context.addExport("productData", t_1);
}
output += "<ul class=\"c-product-footer__ul u-clearfix js-product-social-links\"\n        data-canonical=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "canonicalUrl"), env.opts.autoescape);
output += "\"\n        data-product-name=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productData")),"displayName")), env.opts.autoescape);
output += "\"\n        data-product-image=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "scene7ImageUrl"), env.opts.autoescape);
output += "\"\n    >\n\n        <li class=\"c-product-footer__li\">\n\n            <a ";
output += runtime.suppressValue((lineno = 16, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","social media share | facebook",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productData")),"displayName")])), env.opts.autoescape);
output += " href=\"https://www.facebook.com/sharer/sharer.php?u=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "canonicalUrl"), env.opts.autoescape);
output += "\" class=\"c-social__a c-social__a--social-facebook js-product-facebook\">\n                ";
env.getTemplate("social/facebook-share.j2", false, "product/templates/product-social-links.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n            </a>\n\n        </li>\n\n        <li class=\"c-product-footer__li\">\n\n            <a ";
output += runtime.suppressValue((lineno = 24, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","social media share | twitter",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productData")),"displayName")])), env.opts.autoescape);
output += " href=\"https://twitter.com/intent/tweet?text=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productData")),"displayName")), env.opts.autoescape);
output += "%20";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "canonicalUrl"), env.opts.autoescape);
output += "\" class=\"c-social__a c-social__a--social-twitter js-product-twitter\">\n                ";
env.getTemplate("social/twitter-share.j2", false, "product/templates/product-social-links.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n            </a>\n\n        </li>\n\n        <li class=\"c-product-footer__li\">\n\n            <a ";
output += runtime.suppressValue((lineno = 32, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","social media share | pinterest",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productData")),"displayName")])), env.opts.autoescape);
output += " href=\"https://www.pinterest.com/pin/create/button/?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "canonicalUrl"), env.opts.autoescape);
output += "&media=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "scene7ImageUrl"), env.opts.autoescape);
output += "\" class=\"c-social__a c-social__a--social-pinterest js-product-pinterest\">\n                ";
env.getTemplate("social/pinterest-share.j2", false, "product/templates/product-social-links.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n            </a>\n\n        </li>\n\n    </ul>\n\n    <p class=\"c-product-footer__p c-product-footer__p--below\">\n         ";
output += runtime.suppressValue((lineno = 41, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-detail_footer-social"])), env.opts.autoescape);
output += "\n    </p>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-social-links.j2"] , dependencies)